export default __webpack_public_path__ + "static/media/voice_slider003.2e950b01.png";